<template>
  <v-dialog v-model="editing" width="500">

    <template></template>



    <v-dialog v-model="confirmDeleteDialog" width="500" height="200">

      <template></template>
      <confirm-modal
          v-if="confirmDeleteDialog"
          :confirmationText="confirmDeleteText"
          @dialog-clicked="deleteItem"
      />
    </v-dialog>
    <v-form ref="form">
      <v-card>
        <v-container>
          <h6 class="text-center py-4 h6">Edit Category</h6>

          <v-text-field v-model="categoryObject.name"/>
          <p v-if="categoryObject.name === ''" class="error--text">Must enter name</p>

          <v-checkbox
              v-model="categoryObject.is_active"
              :label="`Is Active`"
          ></v-checkbox>

          <v-divider></v-divider>

          <v-spacer></v-spacer>
          <v-row align="end">
            <v-col cols="6">

              <v-btn v-if="categoryObject.id" color="error" text @click="confirmDeleteDialog = true">
                Delete
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn color="error" text @click="$emit('dialog-clicked')">
                Cancel
              </v-btn>
              <v-btn color="success" text
                     :disabled="categoryObject.name === ''"
                     @click="submitForm">
                Save
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>

import {mapState, mapActions, mapMutations} from 'vuex'
import ConfirmModal from '../modals/ConfirmModal.vue'

let message = {
  text: '',
  type: 'success',
  alert: true
}

export default {
  components: {ConfirmModal},
  name: 'EditCategoryModal',
  data() {
    return {
      confirmDeleteDialog: false
    }
  },
  props: {
    editing: {
      type: Boolean,
      default: false
    },
    categoryObject: {
      type: Object,
      default: function () {
        return {
          name: '',
        }
      }
    }
  },
  computed: {
    ...mapState({
      tags: state => state.tags.tags,
      categories: state => state.categories.categories
    }),
    isNewCategory() {
      return !('id' in this.categoryObject) || this.categoryObject.id === null
    },
    catNumberOfTags() {
      // Prefer the backend count: the store tag list is active-only, but
      // deleting a category cascades to inactive tags too.
      if (typeof this.categoryObject.number_of_tags === 'number') {
        return this.categoryObject.number_of_tags
      }
      return this.tags.filter(tag => tag.category && tag.category.id === this.categoryObject.id).length
    },
    confirmDeleteText() {

      let text = `Are you sure you want to delete this category? `

      if (this.catNumberOfTags > 0) {
        text += `It will remove all ${this.catNumberOfTags} tags as well.
              Please add these tags to a new category if you would like to keep them associated with photos.`
      }

      return text
    }
  },
  methods: {
    ...mapActions(['createTag',
      'createCategory',
      'updateCategory',
      'deleteCategory']),
    ...mapMutations(['setMessage']),
    async submitForm() {

      let payload = {
        name: this.categoryObject.name,
        is_active: this.categoryObject.is_active
      }

      // Await the write so listeners reacting to the modal closing (e.g. the
      // Manage Tags inactive-list refresh) see post-edit state.
      if (this.isNewCategory) {
        await this.createCategory(payload)
      }
      else{
        payload['id'] = this.categoryObject.id
        await this.updateCategory(payload)
      }

      this.$emit('dialog-clicked')
    },
    async deleteItem(confirmDelete) {
      if (confirmDelete) {
        let payload = {
          id: this.categoryObject.id,
        }

        await this.deleteCategory(payload)

      }
      this.$emit('dialog-clicked')
    }
  }

}
</script>